import React from "react";
import Icon, {
  UsergroupAddOutlined,
  FileTextOutlined,
  AuditOutlined,
  IssuesCloseOutlined,
  ExperimentOutlined,
  BellOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";

// No airplane glyph ships with @ant-design/icons, so this mirrors their
// Outlined set (single currentColor path, 0 0 24 24 viewBox) with the
// standard "flight" silhouette instead of approximating with Rocket/Send.
const AirplaneSvg = () => (
  <svg viewBox="0 0 24 24" focusable="false" width="1em" height="1em" fill="currentColor">
    <path d="M21,16V14L13,9V3.5C13,2.67 12.33,2 11.5,2C10.67,2 10,2.67 10,3.5V9L2,14V16L10,13.5V19L7.5,20.5V22L11.5,21L15.5,22V20.5L13,19V13.5L21,16Z" />
  </svg>
);
const AirplaneOutlined = (props) => <Icon component={AirplaneSvg} {...props} />;

const TAB_ARRAY = [
  {
    label: "User Management",
    icon: <UsergroupAddOutlined className="tab_icon" />,
    url: "/admin/user-management",
  },
  {
    label: "Data Management",
    icon: <AuditOutlined className="tab_icon" />,
    url: "/admin/data-management",
  },
  {
    label: "Status Management",
    icon: <IssuesCloseOutlined className="tab_icon" />,
    url: "/admin/status-management",
  },
  {
    label: "Flight Model Management",
    icon: <AirplaneOutlined className="tab_icon" />,
    url: "/admin/flight-model-management",
  },
  {
    label: "Ranking Algorithm Settings",
    icon: <ExperimentOutlined className="tab_icon" />,
    url: "/admin/ranking-algorithm-settings",
  },
  {
    label: "Logs",
    icon: <FileTextOutlined className="tab_icon" />,
    url: "/admin/logs",
  },
  {
    label: "Defect Count Threshold",
    icon: <BellOutlined className="tab_icon" />,
    url: "/admin/defect-count-threshold",
  },
];

function AdminHeaderTab({ currrentTab }) {
  const navigate = useNavigate();
  return (
    <div style={{ marginBottom: "20px" }}>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px" }}>
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate("/")}
          style={{ padding: 0, display: "flex", alignItems: "center", gap: "6px" }}
        >
          Back to Dashboard
        </Button>
      </div>
      <div
        style={{
          display: "flex",
          gap: "6px",
          flexWrap: "nowrap",
          overflowX: "auto",
          paddingBottom: "6px",
        }}
      >
        {TAB_ARRAY.map((ele) => (
          <div
            key={ele.label}
            className={`admin_tab_wraper ${currrentTab === ele.label && "active_tab"}`}
            onClick={() => currrentTab !== ele.label && navigate(ele.url)}
            style={{ whiteSpace: "nowrap", flexShrink: 0 }}
          >
            <div className="admin_tab_child">
              {ele.icon}
              <p className="tab_label">{ele.label}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminHeaderTab;
